import React from 'react';

//* Styles
import CollapseItemStyle from './style';

const CollapseItem = ({ title, description, disable, status, className }) => {
	return (
		<CollapseItemStyle className={`collapse-item-block ${className || ''}`}>
			<div
				id={'collapse-item'}
				status={status || 'close'}
				className={`${status == 'open' ? 'active' : ''}`}
				disable={disable === false ? 'false' : disable && 'true'}>
				<div id='collapse-title'>{title}</div>

				<div id='collapse-description'>
					<div id='inner-wrapper-description'>{description}</div>
				</div>
			</div>
		</CollapseItemStyle>
	);
};

export default CollapseItem;
